import React, { useEffect } from "react";
import { useBlogContext } from "../../Context/BlogContext";
import Blog from "../../Components/Blog/BlogBody";

import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./ReadBlog.css";

// Helper to safely parse Firestore timestamps
const parseDate = (timestamp) => {
  try {
    if (!timestamp) return new Date(0);
    if (timestamp.toDate) return timestamp.toDate(); // Firestore Timestamp
    if (typeof timestamp === "string" || typeof timestamp === "number") {
      return new Date(timestamp);
    }
    return new Date(0);
  } catch {
    return new Date(0);
  }
};

const ReadBlog = ({ authenticated, setAlertMsg, setAlertColor }) => {
  const { isLoading, blogs } = useBlogContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isLoading) {
    return (
      <div className="loader">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }

  // Filter approved blogs, remove duplicates, and sort by priority
  const approvedBlogs = blogs
    .filter((b) => b.status?.toLowerCase().trim() === "approved")
    .filter((b, idx, self) => idx === self.findIndex((x) => x.id === b.id))
    .sort((a, b) => {
      const prioA = a.priority ?? 9999;
      const prioB = b.priority ?? 9999;
      if (prioA !== prioB) return prioA - prioB;

      const dateA = parseDate(a.publishDate);
      const dateB = parseDate(b.publishDate);
      return dateB - dateA; // newest first if priority same
    });

  return (
    <>
      <Helmet>
        <title>Blogs - VALSCO</title>
        <meta
          name="description"
          content="Explore a collection of insightful blog posts."
        />
      </Helmet>

      {true && (
        <div className="add-blog-container">
          <Link to="/CreateBlog" className="add-blog-btn">
            Add Blog
          </Link>
        </div>
      )}

      <div className="blog-card-container">
        {approvedBlogs.length === 0 ? (
          <p>No approved blogs available at the moment.</p>
        ) : (
          approvedBlogs.map((blog) => (
            <Blog
              key={blog.id}
              currentElement={blog}
              authenticated={authenticated}
              setAlertMsg={setAlertMsg}
              setAlertColor={setAlertColor}
            />
          ))
        )}
      </div>

    </>
  );
};

export default ReadBlog;